import type { IconData } from '@stacksjs/iconify-core'

export const galaxy2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 19a5 5 0 1 0 0 10a5 5 0 0 0 0-10\"/><path d=\"M25.447 14.497c-6.23-1.67-12.633 2.028-14.302 8.257c-1.973 7.363 2.396 14.93 9.759 16.903c10.194 2.731 20.672-3.318 23.404-13.512c2.61-9.742-2.377-19.73-11.329-23.673c-.89-.392-1.66.69-1.174 1.533c2.804 4.852 3.558 10.401 3.558 10.401\"/><path d=\"M22.553 33.504c6.23 1.669 12.633-2.028 14.302-8.258c1.973-7.362-2.397-14.93-9.759-16.903C16.902 5.612 6.424 11.662 3.692 21.856c-2.61 9.741 2.377 19.729 11.329 23.672c.89.392 1.66-.69 1.174-1.532c-2.804-4.853-3.558-10.402-3.558-10.402\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default galaxy2
